import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import TextEditorButton from '../text-editor-button';

export default function createAlignmentButton({ alignment, content: Content, tooltipText }) {
  return class AlignmentButton extends Component {
    static propTypes = {
      setAlignment: PropTypes.func.isRequired,
      alignment: PropTypes.string,
      className: PropTypes.string,
    };

    isActive = () => this.props.alignment === alignment;
    handleClick = () => this.props.setAlignment(alignment);

    render() {
      const {
        setAlignment, // eslint-disable-line no-unused-vars
        alignment, // eslint-disable-line no-unused-vars
        className,
        ...buttonProps
      } = this.props;
      return (
        <TextEditorButton
          className={classNames(className, `text-editor__align-${alignment}-button`)}
          onClick={this.handleClick}
          isActive={this.isActive()}
          icon={Content}
          tooltipText={tooltipText}
          {...buttonProps}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-alignment-button.js